import { apiSlice } from "../apiSlice";

export const customersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addCustomer: builder.mutation({
      query: (data) => ({
        url: "/customers/add-customer",
        method: "POST",
        body: data,
      }),
      invalidatesTags: () => [
        { type: "customers" }, // Invalidate the customer list (only if required)
      ],
    }),

    getCustomers: builder.query({
      query: ({ page, size, companyName }) =>
        `/customers/companies?pageNo=${page}&pageSize=${size}&companyName=${companyName}`,
      keepUnusedDataFor: 600,
      providesTags: (result) => {
        if (result?.content && Array.isArray(result.content)) {
          return [
            { type: "customers" }, // provides tag for Customer list
            ...result.content.map(({ id }) => ({ type: "customer", id })), // provides tag for individual products
          ];
        }
        return [{ type: "customers" }]; // fallback in case content is not available
      },
    }),

    getCustomer: builder.query({
      query: (customerId) => `/customers/customer/${customerId}`,
      providesTags: (result, error, customerId) => [
        { type: "customer", id: customerId }, // Provides a tag for a single customer
      ],
    }),

    updateCustomer: builder.mutation({
      query: (data) => ({
        url: "/customers/customer/update-customer",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "customer", id }, // Invalidate the cache for the updated customer
        { type: "customers" }, // Optionally invalidate the customers list (only if required)
      ],
    }),
    deleteCustomer: builder.mutation({
      query: (customerId) => ({
        url: `/customers/delete-customer/${customerId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { customerId }) => [
        { type: "customers" },
      ],
    }),
  }),
});

export const {
  useGetCustomerQuery,
  useGetCustomersQuery,
  useAddCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,
} = customersApi;
